var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useReducer, useRef } from "react";
import styled from "styled-components";
import { RevealTag } from "../";
var SharedStyles = "\n  display: flex;\n  align-self: flex-start;\n  align-items: center;\n\n  & > * {\n    margin-right: 0.25rem;\n  }\n";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return "\n    ".concat(SharedStyles, "\n    width: 100%;\n    height: 24px;\n    visibility: ").concat(props.visible ? "visible" : "hidden", ";\n    transition: all 1s;\n    justify-content: flex-end;\n  "); });
var HiddenContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  pointer-events: none;\n  visibility: hidden;\n  position: asbolute;\n  height: 0;\n  width: 0;\n"], ["\n  ", "\n  pointer-events: none;\n  visibility: hidden;\n  position: asbolute;\n  height: 0;\n  width: 0;\n"])), SharedStyles);
var dispatch = function (state, action) {
    switch (action.type) {
        case "SET_VISIBLE_CHILDREN": {
            return __assign(__assign({}, state), { visibleChildren: action.payload, isVisible: true });
        }
        default:
            return __assign({}, state);
    }
};
var defaultState = {
    isVisible: false,
    visibleChildren: [],
};
var TagContainer = function (_a) {
    var children = _a.children;
    var _b = useReducer(dispatch, __assign(__assign({}, defaultState), { visibleChildren: [] })), _c = _b[0], visibleChildren = _c.visibleChildren, isVisible = _c.isVisible, componentDispatch = _b[1];
    var containerRef = useRef(null);
    var hiddenRef = useRef(null);
    var calculateChildrenWidth = useCallback(function () {
        if (typeof children === "object") {
            var childArray_1 = children;
            if (!Array.isArray(children)) {
                childArray_1 = [children];
            }
            if (containerRef.current !== null && hiddenRef.current !== null) {
                var container = containerRef.current;
                var containerWidth_1 = container.clientWidth;
                var hidden = hiddenRef.current;
                var kids_1 = Array.from(hidden.children);
                var visible_1 = [];
                var width_1 = 0;
                kids_1.every(function (kid, index) {
                    var style = getComputedStyle(kid);
                    var kidWidth = kid.clientWidth + parseInt(style.marginLeft) + parseInt(style.marginRight);
                    width_1 += kidWidth;
                    if (width_1 <= containerWidth_1 - 28 || (index === kids_1.length - 1 && width_1 <= containerWidth_1)) {
                        // visible.push(React.cloneElement(childArray[index], { key: childArray[index].key }));
                        visible_1.push(childArray_1[index]);
                        return true;
                    }
                    else {
                        visible_1.push(React.createElement(RevealTag, { key: "reveal-tag", numHidden: kids_1.length - index }, children));
                        return false;
                    }
                });
                componentDispatch({ type: "SET_VISIBLE_CHILDREN", payload: visible_1 });
            }
        }
    }, [children, containerRef]);
    useEffect(function () {
        calculateChildrenWidth();
        window.removeEventListener("resize", calculateChildrenWidth);
        window.addEventListener("resize", calculateChildrenWidth);
        return function () {
            window.removeEventListener("resize", calculateChildrenWidth);
        };
    }, [containerRef, hiddenRef, calculateChildrenWidth]);
    return (React.createElement(Container, { visible: isVisible, ref: containerRef },
        visibleChildren,
        React.createElement(HiddenContainer, { ref: hiddenRef }, children)));
};
export default TagContainer;
var templateObject_1, templateObject_2;
